import { Validator } from 'breeze-client';

const notNullOrUndefinedValidator = Validator.required({ allowEmptyStrings: true });
notNullOrUndefinedValidator.name = 'notNullOrUndefined';

export { notNullOrUndefinedValidator };
